// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown--2RNPh","headerWrapper":"headerWrapper--1EkiF"};